import { useHistory } from 'react-router-dom';
import { useMemo } from 'react';

type HistoryType = ReturnType<typeof useHistory>;

type PushArg = Parameters<HistoryType['push']>[0];
type ReplaceArg = Parameters<HistoryType['replace']>[0];

export function useRouter() {
  const history = useHistory();
  return useMemo(
    () => ({
      push: (args: PushArg) => {
        history.push(args);
        return Promise.resolve();
      },
      replace: (args: ReplaceArg) => {
        history.replace(args);
      },
      goBack: () => {
        history.goBack();
      }
    }),
    [history]
  );
}

export default useRouter;
